(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6753],{

/***/ 35450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/age-verification",
      function () {
        return __webpack_require__(2326);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35666);
/* harmony import */ var regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _components_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26976);
/* harmony import */ var _components_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66154);
/* harmony import */ var _components_general_Logo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82352);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97274);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37702);
/* harmony import */ var _reducers_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42235);
/* harmony import */ var _resources_routeConst__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92001);
/* harmony import */ var _resources_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15287);
/* harmony import */ var _utils_cookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63193);
/* harmony import */ var _utils_i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43948);
/* harmony import */ var _utils_isServer__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41252);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56116);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14066);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87379);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58690);





















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        ";\n  background-color: ",
        ";\n  border-radius: 5px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_templateObject(), function(props) {
    return props.$mobile ? "100%" : "600px";
}, _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.realWhite */ .$.realWhite, function(props) {
    return props.$mobile ? "none" : "0 10px 20px 0 rgba(0, 0, 0, 0.1)";
});
var AgeVerificationSchema = yup__WEBPACK_IMPORTED_MODULE_17__/* .object */ .Ry().shape({
    rememberMe: yup__WEBPACK_IMPORTED_MODULE_17__/* .boolean */ .O7().nullable().notRequired(),
    province: _config_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"].drup */ .Z.drup ? yup__WEBPACK_IMPORTED_MODULE_17__/* .string */ .Z_().required() : yup__WEBPACK_IMPORTED_MODULE_17__/* .string */ .Z_().notRequired()
});
var AgeVerification = function() {
    var ref;
    var width = (0,react__WEBPACK_IMPORTED_MODULE_16__.useContext)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .WidthContext */ .E3);
    var mobile = width === "xs";
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_16__.useState)(false), isDenied = ref1[0], setIsDenied = ref1[1];
    var ref2 = (0,_utils_i18n__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)([
        "age-verification"
    ]), t = ref2.tOrNull, getObject = ref2.getObject;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
    var returnUrl = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.returnUrl) || "/";
    var provinceOptions = getObject("form.province.options") || [];
    if (!_utils_isServer__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z && (0,_utils_cookie__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)(_utils_cookie__WEBPACK_IMPORTED_MODULE_9__/* .VISITOR_ID */ .$6) && !returnUrl.includes("age-verification")) {
        // redirect({ location: returnUrl });
        var pageName = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_11__/* .findPageNameByPath */ .tv)(returnUrl);
        var queryParams = returnUrl.split("?")[1];
        if (pageName) {
            router.replace("".concat(pageName, "?").concat(queryParams), returnUrl);
        } else {
            router.replace(returnUrl);
        }
    }
    var initialValues = {
        rememberMe: false,
        province: _config_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"].drup */ .Z.drup ? "ON" : undefined
    };
    var handleSubmit = _asyncToGenerator(regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var pageName, queryParams;
        return regenerator_runtime__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_reducers_user__WEBPACK_IMPORTED_MODULE_6__/* .acquireVisitorId */ .N8)(values.rememberMe);
                case 2:
                    pageName = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_11__/* .findPageNameByPath */ .tv)(returnUrl);
                    queryParams = returnUrl.split("?")[1];
                    if (!_utils_isServer__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z) {
                        // save province value to local storage for product query to use as a filter
                        window.localStorage.setItem("province", values.province);
                    }
                    if (pageName) {
                        router.replace("".concat(pageName, "?").concat(queryParams), returnUrl);
                    } else {
                        router.replace(returnUrl);
                    }
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_12__/* .useFormik */ .TA)({
        initialValues: initialValues,
        validationSchema: AgeVerificationSchema,
        onSubmit: handleSubmit
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Page */ .T3, {
        showHeader: false,
        showFooter: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            style: {
                paddingTop: mobile ? 0 : 60,
                paddingBottom: mobile ? 0 : 160,
                minHeight: "100vh",
                background: mobile ? _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.realWhite */ .$.realWhite : _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.blueGradientFroAgeVerification */ .$.blueGradientFroAgeVerification
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                container: true,
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCard, {
                        container: true,
                        $mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                style: {
                                    marginTop: 40,
                                    marginBottom: 15
                                },
                                item: true,
                                justify: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general_Logo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    mini: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                justify: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 11,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .StyledParagraph */ .MU, {
                                        guideline: "h2",
                                        color: _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.blue */ .$.blue,
                                        align: "center",
                                        fade: "bottom",
                                        children: isDenied ? t("denied.title") : t("title")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                justify: "center",
                                item: true,
                                style: {
                                    marginBottom: 46
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 10,
                                    sm: 8,
                                    children: isDenied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                        justify: "center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .StyledParagraph */ .MU, {
                                            guideline: "p1",
                                            color: _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.black */ .$.black,
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: t("denied.description")
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_12__/* .FormikProvider */ .Hy, {
                                                value: formik,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                                    onSubmit: formik.handleSubmit,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                                            justify: "center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .StyledParagraph */ .MU, {
                                                                guideline: "p1",
                                                                color: _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.black */ .$.black,
                                                                align: "center",
                                                                fade: "bottom",
                                                                children: t("form.age.label")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                                            justify: "center",
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                    item: true,
                                                                    xs: 6,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
                                                                        type: "submit",
                                                                        fullWidth: true,
                                                                        loading: formik.isSubmitting,
                                                                        children: t("form.age.yes")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                    item: true,
                                                                    xs: 6,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
                                                                        secondary: true,
                                                                        fullWidth: true,
                                                                        onClick: function() {
                                                                            return setIsDenied(true);
                                                                        },
                                                                        children: t("form.age.no")
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        _config_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"].drup */ .Z.drup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .StyledParagraph */ .MU, {
                                                                        guideline: "p1",
                                                                        color: _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.black */ .$.black,
                                                                        fade: "bottom",
                                                                        children: t("form.province.label")
                                                                    })
                                                                }),
                                                                !lodash__WEBPACK_IMPORTED_MODULE_13___default().isEmpty(provinceOptions) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                                                                    justify: "center",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                        item: true,
                                                                        xs: 10,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_form__WEBPACK_IMPORTED_MODULE_2__/* .FormikSelectField */ ._3, {
                                                                            type: "text",
                                                                            name: "province",
                                                                            placeholder: "Province",
                                                                            children: Object.keys(provinceOptions).map(function(k) {
                                                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                                                    value: k,
                                                                                    children: provinceOptions[k]
                                                                                }, k);
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_form__WEBPACK_IMPORTED_MODULE_2__/* .FormikCheckBoxField */ .Qn, {
                                                            type: "checkbox",
                                                            name: "rememberMe",
                                                            label: t("form.checkbox_label")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_general__WEBPACK_IMPORTED_MODULE_3__/* .StyledParagraph */ .MU, {
                                                fade: "bottom",
                                                guideline: "p2",
                                                align: "center",
                                                color: _resources_styles__WEBPACK_IMPORTED_MODULE_8__/* .color.black */ .$.black,
                                                children: [
                                                    t("form.tnc.part1"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_14__["default"], {
                                                        href: _resources_routeConst__WEBPACK_IMPORTED_MODULE_7__/* .TERMSANDCONDITIONS */ .vz,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            className: "link-blue",
                                                            children: t("form.tnc.part2")
                                                        })
                                                    }),
                                                    t("form.tnc.part3"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_14__["default"], {
                                                        href: _resources_routeConst__WEBPACK_IMPORTED_MODULE_7__/* .PRIVACYPOLICY */ .N0,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            className: "link-blue",
                                                            children: t("form.tnc.part4")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};
AgeVerification.ageVerification = false;
/* harmony default export */ __webpack_exports__["default"] = (AgeVerification);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8690,9774,2888,179], function() { return __webpack_exec__(35450); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);